module.exports = __webpack_public_path__ + "static/media/FideoJengibre.7b9083ea.jpg";